export default __webpack_public_path__ + "static/media/m5.fbcd839e.jpg";